import BookmarkIcon from "@heroicons/react/24/solid/BookmarkIcon";
import BriefcaseIcon from "@heroicons/react/24/solid/BriefcaseIcon";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import HomeModernIcon from "@heroicons/react/24/solid/HomeModernIcon";
import PlayCircleIcon from "@heroicons/react/24/solid/PlayCircleIcon";
import { ButtonBase } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../assets/colors";

export const OuterWrapper = styling("div")({
  // maxWidth: "1440px",
  maxWidth: "unset",
  margin: "0 auto 64px",
  height: "100%",
});

export const InnerWrapper = styling("div")({
  // padding: "0 6.25rem",
  padding: "0",

  "@media (max-width: 1280px)": {
    padding: "0",
  },

  "@media (max-width: 640px)": {
    // padding: "0 1rem",
  },
});

export const ContentLayout = styling("div")({
  display: "flex",
  gap: "1.5rem",
  alignItems: "flex-start",
  padding: "32px 40px",
  maxWidth: "1360px",
  margin: "0 auto",

  "@media (max-width: 1280px)": {
    display: "block",
    padding: "32px 0px",
  },

  "@media (max-width: 640px)": {
    padding: "32px 0px",
  },
});

export const MainColumn = styling("div")({
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  position: "relative",
  zIndex: 1,
});

export const AdRail = styling("aside")({
  width: "18.75rem",
  minWidth: "18.75rem",
  position: "sticky",
  top: "13rem",
  zIndex: 0,
  alignSelf: "flex-start",
});

export const AdRailStack = styling("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

export const AdSlot = styling("div")({
  background: "#f8f6ff",
  border: "1px dashed rgba(93, 65, 187, 0.35)",
  borderRadius: "0.75rem",
  padding: "0px",
  color: "#5d41bb",
  textAlign: "center",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "auto",
    display: "block",
    borderRadius: "0.5rem",
  },
});

export const AdImage = styling("img")({
  width: "100%",
  height: "auto",
  display: "block",
  objectFit: "contain",
});

export const AdLabel = styling("div")({
  fontSize: "0.625rem",
  letterSpacing: "0.08em",
  color: "rgba(93, 65, 187, 0.65)",
  marginBottom: "0.5rem",
});

export const AdSizeText = styling("div")({
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: 1.1,
});

export const AdSubText = styling("div")({
  fontSize: "0.875rem",
  marginTop: "0.25rem",
  color: "rgba(93, 65, 187, 0.75)",
});

export const InlineAdBlock = styling("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  borderRadius: "8px",

  "@media (max-width: 1280px)": {
    padding: "0px 1.5rem",
  },
});

export const InlineAdColumn = styling("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "1rem",

  "@media (max-width: 1280px)": {
    padding: "0px 1.5rem",
  },

  // Nested blocks already sit inside the padded column
  "& > *": {
    padding: 0,
  },
});

export const InlineAdRow = styling("div")({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "20px",
  padding: "0px 1.5rem",
});

// flex-grow = width/height so equal-height images keep their aspect ratios
export const InlineAdRowItem = styling("div", {
  shouldForwardProp: (prop) => prop !== "$aspect",
})(({ $aspect = 1 }) => ({
  flex: `${$aspect} 1 0%`,
  minWidth: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",

  "& > *": {
    maxHeight: "none",
    width: "100%",
    height: "auto",
    padding: 0,
  },

  "& img": {
    width: "100%",
    maxHeight: "none",
    height: "auto",
    display: "block",
    objectFit: "contain",
    borderRadius: "8px",
  },
}));

export const InlineAdSlot = styling("div")({
  width: "100%",
  maxHeight: "unset",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",

  "& img": {
    width: "100%",
    maxHeight: "unset",
    height: "auto",
    display: "block",
    objectFit: "contain",
  },

  "@media (max-width: 640px)": {
    display: "block",
    maxHeight: "none",

    "& img": {
      width: "100%",
      maxWidth: "100%",
      maxHeight: "none",
      height: "auto",
      objectFit: "contain",
    },
  },
});

export const InlineAdSlotRightRail = styling("div")({
  width: "100%",
  maxHeight: "300px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "14px",

  "& img": {
    width: "100%",
    maxHeight: "300px",
    height: "auto",
    display: "block",
    objectFit: "contain",
  },

  "@media (max-width: 640px)": {
    display: "block",
    maxHeight: "none",

    "& img": {
      width: "100%",
      maxWidth: "100%",
      maxHeight: "none",
      height: "auto",
      objectFit: "contain",
    },
  },
});

export const InlineAdSlotBottomRail = styling("div")({
  width: "100%",
  maxHeight: "600px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "14px",

  "& img": {
    width: "100%",
    maxHeight: "600px",
    height: "auto",
    display: "block",
    objectFit: "contain",
  },

  "@media (max-width: 640px)": {
    display: "block",
    maxHeight: "none",

    "& img": {
      width: "100%",
      maxWidth: "100%",
      maxHeight: "none",
      height: "auto",
      objectFit: "contain",
    },
  },
});

export const BottomAdContainer = styling("div")({
  width: "100%",
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
});

export const BottomAdLabel = styling("div")({
  color: "#A890D4",
  fontSize: "10px",
  fontFamily: "Inter",
  fontWeight: 400,
  textTransform: "uppercase",
  lineHeight: "15px",
  letterSpacing: "1.4px",
  marginBottom: "0.5rem",
});

export const BottomAdSlot = styling("div")({
  width: "100%",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& img": {
    width: "100%",
    height: "100%",
    display: "block",
    objectFit: "cover",
  },
});

export const BottomAdMainLabel = styling("div")({
  color: "#9B76E8",
  fontSize: "10px",
  fontFamily: "Inter",
  fontWeight: 600,
  textTransform: "uppercase",
  lineHeight: "15px",
  letterSpacing: "1.5px",
});

export const BottomAdSizeRow = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.35rem",
  color: "#512ACC",
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "25.2px",
  fontSize: "25.2px",
});

export const BottomAdMultiply = styling("span")({
  color: "#9B76E8",
  fontSize: "14.4px",
  fontWeight: 400,
  lineHeight: "14.4px",
});

export const BottomAdType = styling("div")({
  color: "#7C5CBF",
  fontSize: "11.7px",
  fontFamily: "Inter",
  fontWeight: 500,
  lineHeight: "11.7px",
});

export const BottomAdBadge = styling("div")({
  position: "absolute",
  top: "8px",
  right: "8px",
  padding: "2px 6px",
  borderRadius: "3px",
  background: "#512ACC",
  color: "#fff",
  fontSize: "9px",
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "13.5px",
  letterSpacing: "1px",
});

export const SectionContainer = styling("section")({
  maxWidth: "1440px",
  margin: "0 auto",
  width: "100%",
  padding: "2rem auto",

  "@media (max-width: 1280px)": {
    padding: "0 1.5rem",
  },

  "@media (max-width: 640px)": {
    padding: "1.5rem auto",
  },
});

export const SocialMediaContainer = styling("section")({
  maxWidth: "1440px",
  padding: "0 2rem",
});

export const LinkWrapper = styling(Link)({
  width: "100%",
  height: "100%",
  textDecoration: "none",
  color: Color.black,
});

export const FlexContainer = styling(Box)({
  display: "flex",
  width: "100%",
});

export const BoxContainer = styling(Box)({
  transition: "all 0.15s ease-in-out",
});

export const HScrollContainer = styling(Stack)({
  overflowX: "scroll",
  overflowY: "hidden",

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const TextStyled = styling(Typography)({});

export const CompanyLogo = styling("img")({
  background: Color.white,
  objectFit: "contain",
  borderRadius: "0.5rem",
  border: "1px solid rgba(0, 0, 0, 0.64)",
  userSelect: "none",

  transition: "all 0.1s ease-in-out",
});

export const ButtonStyled = styling(ButtonBase)({
  background: Color.white,
  borderRadius: "32rem",
  border: `1px solid ${Color.black}`,
  width: "2.3125rem",
  height: "2.3125rem",

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },

  "&:disabled": {
    opacity: "0.25",
    cursor: "none",
  },
});

export const DividerStyled = styling(Divider)({
  // margin: "2rem 0",
  margin: "0",

  "@media (max-width: 640px)": {
    // margin: "1.5rem 0",
  },
});

export const CircularProgressStyled = styling(CircularProgress)({});

export const CustomIcon = styling(SvgIcon)({
  fontSize: "1.5rem",
});

export const IndustryIconStyled = styling(HomeModernIcon)({
  height: "16px",
  width: "16px",
});

export const JobIconStyled = styling(BriefcaseIcon)({
  height: "16px",
  width: "16px",
});

export const BookmarkIconStyled = styling(BookmarkIcon)({
  color: Color.white,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});

export const BookmarkFilledIconStyled = styling(BookmarkIcon)({
  color: Color.hiredlyPurple,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});

export const ArrowRightIconStyled = styling(ChevronRightIcon)({
  height: "1.5rem",
  width: "1.125rem",
  marginLeft: "0.125rem",
});

export const ArrowLeftIconStyled = styling(ChevronLeftIcon)({
  height: "1.5rem",
  width: "1.125rem",
});

export const PlayIconStyled = styling(PlayCircleIcon)({
  color: Color.white,
  strokeWidth: "0.5px",
  stroke: "rgba(0, 0, 0, 0.38)",
  height: "50px",
  width: "50px",
});
